function novaChaveTrechoFaixa() {
  return `faixa-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function criarFaixaVaziaNoEstado(defaultTalhaoId = null) {
  return {
    key: novaChaveTrechoFaixa(),
    talhaoId: defaultTalhaoId,
    linhaInicio: '',
    linhaFim: '',
  };
}

export function calcularColhido(medida, linhas) {
  if (!Array.isArray(linhas) || linhas.length === 0) return 0;
  if (medida === 'Linha/Carreira') return linhas.length;
  return linhas.reduce((acc, l) => acc + (Number(l.plants) || 0), 0);
}

export function rotuloLinhaProducaoExibicao(linha) {
  const codigoLinhaVal = String(linha?.code ?? '').trim();
  const numeroTalhaoVal =
    linha?.talhaoNumero != null ? String(linha.talhaoNumero).trim() : '';
  if (numeroTalhaoVal) {
    return `${numeroTalhaoVal} · linha ${codigoLinhaVal}`;
  }
  const nomeTalhaoVal =
    linha?.talhaoNome != null ? String(linha.talhaoNome).trim() : '';
  if (nomeTalhaoVal) {
    return `${nomeTalhaoVal} — linha ${codigoLinhaVal}`;
  }
  return codigoLinhaVal || '—';
}

export function normalizarLinhaProducao(linha) {
  const talhaoLinhasId = linha?.talhaoLinhasId ?? linha?.id;
  if (talhaoLinhasId == null || talhaoLinhasId === '') return null;
  const base = {
    talhaoLinhasId: Number(talhaoLinhasId),
    code: String(linha?.code ?? ''),
    plants: Number(linha?.plants) || 0,
  };
  if (linha?.gloTalhaoId != null && linha.gloTalhaoId !== '') {
    base.gloTalhaoId = Number(linha.gloTalhaoId);
  }
  const numeroTalhao = linha?.talhaoNumero;
  if (numeroTalhao != null && String(numeroTalhao).trim() !== '') {
    base.talhaoNumero = String(numeroTalhao).trim();
  }
  const nomeTalhao = linha?.talhaoNome;
  if (nomeTalhao != null && String(nomeTalhao).trim() !== '') {
    base.talhaoNome = String(nomeTalhao).trim();
  }
  return base;
}

export function normalizarLinhasLista(linhas) {
  if (!Array.isArray(linhas)) return [];
  return linhas.map(normalizarLinhaProducao).filter(Boolean);
}

export function normalizarLinhasDisponiveisResponse(talhoes) {
  if (!Array.isArray(talhoes)) return [];
  return talhoes.map((talhaoLinhas) => ({
    ...talhaoLinhas,
    linhas: normalizarLinhasLista(talhaoLinhas.linhas),
  }));
}

export function montarLinhasDaFaixa(linhasTalhao, inicio, fim) {
  if (!linhasTalhao?.length || !inicio || !fim) return { linhas: [] };

  const idxInicio = linhasTalhao.findIndex(
    (linhaItem) => linhaItem.code === inicio,
  );
  const idxFim = linhasTalhao.findIndex((linhaItem) => linhaItem.code === fim);

  if (idxInicio === -1) {
    return { linhas: [], erro: `Linha inicial "${inicio}" não encontrada` };
  }
  if (idxFim === -1) {
    return { linhas: [], erro: `Linha final "${fim}" não encontrada` };
  }

  const start = Math.min(idxInicio, idxFim);
  const end = Math.max(idxInicio, idxFim);
  const trecho = linhasTalhao.slice(start, end + 1);

  return { linhas: normalizarLinhasLista(trecho) };
}

export function indiceCodigoLinha(linhas, code) {
  if (!Array.isArray(linhas) || code == null || code === '') return -1;
  return linhas.findIndex((linha) => String(linha.code) === String(code));
}

export function codigosParaIntervaloIndices(linhas, linhaInicio, linhaFim) {
  if (!linhas?.length) return [0, 0];
  let idxInicio = indiceCodigoLinha(linhas, linhaInicio);
  let idxFim = indiceCodigoLinha(linhas, linhaFim);
  if (idxInicio === -1 && idxFim === -1) return [0, 0];
  if (idxInicio === -1) idxInicio = idxFim;
  if (idxFim === -1) idxFim = idxInicio;
  return [Math.min(idxInicio, idxFim), Math.max(idxInicio, idxFim)];
}

export function indicesParaCodigosLinha(linhas, idxInicio, idxFim) {
  if (!linhas?.length) return { linhaInicio: '', linhaFim: '' };
  const start = Math.min(idxInicio, idxFim);
  const end = Math.max(idxInicio, idxFim);
  return {
    linhaInicio: String(linhas[start]?.code ?? ''),
    linhaFim: String(linhas[end]?.code ?? ''),
  };
}

export function obterIndicesLinhasUsadosNoTalhao(linhasTalhao, faixas, talhaoId) {
  const indicesUsados = new Set();
  if (!linhasTalhao?.length || talhaoId == null) return indicesUsados;

  (faixas ?? []).forEach((trecho) => {
    if (Number(trecho.talhaoId) !== Number(talhaoId)) return;
    if (!trecho.linhaInicio || !trecho.linhaFim) return;

    const [start, end] = codigosParaIntervaloIndices(
      linhasTalhao,
      trecho.linhaInicio,
      trecho.linhaFim,
    );
    for (let i = start; i <= end; i += 1) {
      indicesUsados.add(i);
    }
  });

  return indicesUsados;
}

export function obterProximoIndiceLinhaDisponivel(linhasTalhao, faixas, talhaoId) {
  if (!linhasTalhao?.length) return -1;

  const indicesUsados = obterIndicesLinhasUsadosNoTalhao(
    linhasTalhao,
    faixas,
    talhaoId,
  );

  for (let i = 0; i < linhasTalhao.length; i += 1) {
    if (!indicesUsados.has(i)) return i;
  }

  return -1;
}

export function criarNovoTrechoFaixa(
  linhasDisponiveis,
  faixasExistentes,
  defaultTalhaoId = null,
) {
  const ultimoTalhao = faixasExistentes?.length
    ? faixasExistentes[faixasExistentes.length - 1]?.talhaoId
    : null;
  const talhaoId =
    defaultTalhaoId != null ? defaultTalhaoId : ultimoTalhao ?? null;

  const base = {
    key: novaChaveTrechoFaixa(),
    talhaoId: talhaoId != null ? Number(talhaoId) : null,
    linhaInicio: '',
    linhaFim: '',
  };

  if (talhaoId == null) return base;

  const talhaoCadastro = (linhasDisponiveis ?? []).find(
    (tItem) => Number(tItem.talhaoId) === Number(talhaoId),
  );
  const linhasTalhao = talhaoCadastro?.linhas ?? [];
  const proximoIdx = obterProximoIndiceLinhaDisponivel(
    linhasTalhao,
    faixasExistentes,
    talhaoId,
  );

  if (proximoIdx === -1) return base;

  return {
    ...base,
    ...indicesParaCodigosLinha(linhasTalhao, proximoIdx, proximoIdx),
  };
}

export function contarLinhasNoIntervalo(linhas, linhaInicio, linhaFim) {
  if (!linhas?.length || (!linhaInicio && !linhaFim)) return 0;
  const [start, end] = codigosParaIntervaloIndices(linhas, linhaInicio, linhaFim);
  if (linhaInicio === '' && linhaFim === '') return 0;
  return end - start + 1;
}

export function marcasSliderLinhas(linhas, maxMarcas = 5) {
  if (!linhas?.length) return [];
  const ultimo = linhas.length - 1;
  if (linhas.length <= maxMarcas) {
    return linhas.map((linha, indice) => ({
      value: indice,
      label: String(linha.code),
    }));
  }
  const pontos = [
    0,
    Math.round(ultimo * 0.25),
    Math.round(ultimo * 0.5),
    Math.round(ultimo * 0.75),
    ultimo,
  ];
  return [...new Set(pontos)].map((indice) => ({
    value: indice,
    label: String(linhas[indice].code),
  }));
}

export function normalizarFaixasParaEstado(item) {
  if (!item) return [criarFaixaVaziaNoEstado()];

  const trechosServidor =
    Array.isArray(item.faixas) &&
    item.faixas.every(
      (f) =>
        f &&
        typeof f.linhaInicio !== 'undefined' &&
        typeof f.linhaFim !== 'undefined',
    );

  if (trechosServidor && item.faixas.length > 0) {
    return item.faixas.map((segmento) => ({
      key: novaChaveTrechoFaixa(),
      talhaoId: segmento.talhaoId != null ? Number(segmento.talhaoId) : null,
      linhaInicio: String(segmento.linhaInicio ?? ''),
      linhaFim: String(segmento.linhaFim ?? ''),
    }));
  }

  if (item.talhaoId != null && item.linhaInicio && item.linhaFim) {
    return [
      {
        key: novaChaveTrechoFaixa(),
        talhaoId: Number(item.talhaoId),
        linhaInicio: String(item.linhaInicio),
        linhaFim: String(item.linhaFim),
      },
    ];
  }

  return [criarFaixaVaziaNoEstado()];
}

export function agruparLinhasDeMultiplasFaixas(linhasDisponiveis, faixas) {
  const errosTrecho = [];
  const todasLinhas = [];

  const lista = faixas ?? [];

  lista.forEach((trecho, indiceTrecho) => {
    const { talhaoId, linhaInicio, linhaFim } = trecho;
    if (!talhaoId || !linhaInicio || !linhaFim) return;

    const talhaoCadastro = (linhasDisponiveis ?? []).find(
      (tItem) => Number(tItem.talhaoId) === Number(talhaoId),
    );
    if (!talhaoCadastro?.linhas?.length) {
      errosTrecho.push(
        `Trecho ${indiceTrecho + 1}: talhão não encontrado nas linhas disponíveis.`,
      );
      return;
    }
    const resultado = montarLinhasDaFaixa(
      talhaoCadastro.linhas,
      linhaInicio,
      linhaFim,
    );
    if (resultado.erro) {
      errosTrecho.push(`Trecho ${indiceTrecho + 1}: ${resultado.erro}`);
      return;
    }
    const linhasComMetaTalhao = (resultado.linhas ?? []).map((linhaItem) => ({
      ...linhaItem,
      gloTalhaoId:
        linhaItem.gloTalhaoId !== undefined
          ? linhaItem.gloTalhaoId
          : Number(talhaoId),
      talhaoNumero:
        linhaItem.talhaoNumero ??
        (talhaoCadastro.numero != null &&
        String(talhaoCadastro.numero).trim() !== ''
          ? String(talhaoCadastro.numero).trim()
          : undefined),
      talhaoNome:
        linhaItem.talhaoNome ??
        (talhaoCadastro.nome != null &&
        String(talhaoCadastro.nome).trim() !== ''
          ? String(talhaoCadastro.nome).trim()
          : undefined),
    }));
    todasLinhas.push(...linhasComMetaTalhao);
  });

  const idsVisto = new Set();
  let temSobreposicao = false;
  todasLinhas.forEach((linhaUm) => {
    if (idsVisto.has(linhaUm.talhaoLinhasId)) {
      temSobreposicao = true;
    }
    idsVisto.add(linhaUm.talhaoLinhasId);
  });

  return { linhas: todasLinhas, errosTrecho, temSobreposicao };
}

export function normalizarLinhasDoGet(linhas) {
  return normalizarLinhasLista(linhas);
}

export function obterListaFaixasParaPayload(item) {
  const faixasInput = Array.isArray(item?.faixas) ? item.faixas : null;
  if (faixasInput?.length) {
    const limpas = faixasInput
      .filter(
        (segmentoUm) =>
          segmentoUm.talhaoId != null &&
          segmentoUm.linhaInicio !== '' &&
          segmentoUm.linhaFim !== '',
      )
      .map((segmentoUm) => ({
        talhaoId: Number(segmentoUm.talhaoId),
        linhaInicio: String(segmentoUm.linhaInicio),
        linhaFim: String(segmentoUm.linhaFim),
      }));
    if (limpas.length) return limpas;
  }
  if (
    item?.talhaoId != null &&
    item.linhaInicio !== '' &&
    item.linhaFim !== ''
  ) {
    return [
      {
        talhaoId: Number(item.talhaoId),
        linhaInicio: String(item.linhaInicio),
        linhaFim: String(item.linhaFim),
      },
    ];
  }
  return [];
}

function resolverCodigoTalhaoExibicao(talhaoId, vinculo, talhoesMap) {
  if (talhaoId == null || talhaoId === '') return '';
  const idNum = Number(talhaoId);

  const entradaMapa =
    talhoesMap?.[idNum] ??
    talhoesMap?.[talhaoId] ??
    talhoesMap?.[String(talhaoId)];
  const numeroMapa = entradaMapa?.numero;
  if (numeroMapa != null && String(numeroMapa).trim() !== '') {
    return String(numeroMapa).trim();
  }

  const faixaBruta = (
    Array.isArray(vinculo?.faixas) ? vinculo.faixas : []
  ).find((segmento) => Number(segmento?.talhaoId) === idNum);
  const numeroFaixa = faixaBruta?.talhaoNumero;
  if (numeroFaixa != null && String(numeroFaixa).trim() !== '') {
    return String(numeroFaixa).trim();
  }

  const linhaReferencia = (vinculo?.linhas ?? []).find(
    (linhaItem) =>
      Number(linhaItem.gloTalhaoId ?? linhaItem.talhaoId) === idNum,
  );
  const numeroLinha = linhaReferencia?.talhaoNumero;
  if (numeroLinha != null && String(numeroLinha).trim() !== '') {
    return String(numeroLinha).trim();
  }

  return String(idNum);
}

function formatarTrechoFaixaResumo(faixaUm, vinculo, talhoesMap) {
  const intervalo = `linhas ${faixaUm.linhaInicio}–${faixaUm.linhaFim}`;
  const codigoTalhao = resolverCodigoTalhaoExibicao(
    faixaUm.talhaoId,
    vinculo,
    talhoesMap,
  );
  if (codigoTalhao) {
    return `${codigoTalhao} · ${intervalo}`;
  }
  return intervalo;
}

export function formatarResumoFaixa(vinculo, talhoesMap) {
  if (vinculo?.tipoEntrada !== 'faixa') return '';

  const listaFaixa =
    obterListaFaixasParaPayload(vinculo)?.filter(
      (f) => f.talhaoId != null && f.linhaInicio !== '' && f.linhaFim !== '',
    ) ?? [];

  if (listaFaixa.length === 0) return '';

  const partes = listaFaixa.map((faixaUm) =>
    formatarTrechoFaixaResumo(faixaUm, vinculo, talhoesMap),
  );

  let texto = partes.join(' + ');

  const totalPlantas =
    vinculo.linhas?.reduce(
      (acc, linhaUm) => acc + (Number(linhaUm.plants) || 0),
      0,
    ) ?? 0;
  const colhido = Number(vinculo.colhido);

  let totalNumero = 0;
  if (totalPlantas > 0) {
    totalNumero = totalPlantas;
  } else if (!Number.isNaN(colhido) && colhido > 0) {
    totalNumero = colhido;
  }
  if (totalNumero > 0) {
    texto += ` · ${totalNumero} plantas`;
  }

  return texto;
}

export function buildTalhoesMap(linhasDisponiveis) {
  if (!Array.isArray(linhasDisponiveis)) return {};
  return linhasDisponiveis.reduce((acc, tItem) => {
    if (tItem?.talhaoId == null) return acc;
    acc[Number(tItem.talhaoId)] = tItem;
    return acc;
  }, {});
}
